import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const BUILD_STORAGE_KEY = "app-build-id";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const renderApp = () => {
  createRoot(rootElement).render(<App />);
};

async function bootstrap() {
  if (typeof window === "undefined") {
    renderApp();
    return;
  }

  const previousBuildId = localStorage.getItem(BUILD_STORAGE_KEY);
  const currentBuildId = __APP_BUILD_ID__;

  if (previousBuildId && previousBuildId !== currentBuildId) {
    localStorage.setItem(BUILD_STORAGE_KEY, currentBuildId);

    try {
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }

      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
      }
    } catch (error) {
      console.warn("[PWA] Failed to fully purge old caches:", error);
    }

    window.location.reload();
    return;
  }

  localStorage.setItem(BUILD_STORAGE_KEY, currentBuildId);
  renderApp();
}

void bootstrap();
